const WhiteGloveSupportSection = () => {
  return <section className='flex flex-col gap-6 px-[60px] py-10 text-center md:px-[100px] md:py-[70px]' data-sentry-component="WhiteGloveSupportSection" data-sentry-source-file="WhiteGloveSupportSection.tsx">
      <h2 className='font-wasgaten text-[30px] leading-[1.2] tracking-[-0.015em] text-secondary-500 md:text-[42px]'>
        White glove support, start to finish
      </h2>

      <p className='text-[15px] leading-[1.7] text-brand-dark md:text-[25px] md:leading-[1.5]'>
        When plans shift or questions come up, you&apos;re not on your own. Our
        dedicated support team can work alongside you for every stay{" "}
        <span className='font-semibold'>
          to make sure everything runs smoothly.
        </span>
      </p>
    </section>;
};
export default WhiteGloveSupportSection;